/**
 * Realizacje Gallery - Lightbox + Toggle
 *
 * @package WL_Theme
 */
(function() {
    'use strict';

    // ========================================
    // Toggle "Pokaz wszystkie"
    // ========================================
    function initToggles() {
        var toggles = document.querySelectorAll('.realizacja-card__toggle');

        toggles.forEach(function(btn) {
            btn.addEventListener('click', function() {
                var gallery = btn.closest('.realizacja-card__gallery');
                var isExpanded = gallery.classList.toggle('is-expanded');
                var moreText = btn.querySelector('.realizacja-card__toggle-more');
                var lessText = btn.querySelector('.realizacja-card__toggle-less');

                moreText.hidden = isExpanded;
                lessText.hidden = !isExpanded;
            });
        });
    }

    // ========================================
    // Lightbox
    // ========================================
    var lightbox = null;
    var lightboxImg = null;
    var lightboxCounter = null;
    var currentImages = [];
    var currentIndex = 0;
    var touchStartX = 0;
    var touchEndX = 0;

    function createLightbox() {
        lightbox = document.createElement('div');
        lightbox.className = 'wl-lightbox';
        lightbox.setAttribute('role', 'dialog');
        lightbox.setAttribute('aria-label', 'Podglad zdjecia');
        lightbox.innerHTML =
            '<button type="button" class="wl-lightbox__close" aria-label="Zamknij">&times;</button>' +
            '<button type="button" class="wl-lightbox__nav wl-lightbox__nav--prev" aria-label="Poprzednie zdjecie">&#8249;</button>' +
            '<img class="wl-lightbox__img" src="" alt="">' +
            '<button type="button" class="wl-lightbox__nav wl-lightbox__nav--next" aria-label="Nastepne zdjecie">&#8250;</button>' +
            '<div class="wl-lightbox__counter"></div>';

        document.body.appendChild(lightbox);

        lightboxImg = lightbox.querySelector('.wl-lightbox__img');
        lightboxCounter = lightbox.querySelector('.wl-lightbox__counter');

        // Close
        lightbox.querySelector('.wl-lightbox__close').addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', function(e) {
            if (e.target === lightbox) closeLightbox();
        });

        // Nav
        lightbox.querySelector('.wl-lightbox__nav--prev').addEventListener('click', function() {
            navigate(-1);
        });
        lightbox.querySelector('.wl-lightbox__nav--next').addEventListener('click', function() {
            navigate(1);
        });

        // Touch
        lightbox.addEventListener('touchstart', function(e) {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });
        lightbox.addEventListener('touchend', function(e) {
            touchEndX = e.changedTouches[0].screenX;
            var diff = touchStartX - touchEndX;
            if (Math.abs(diff) > 50) {
                navigate(diff > 0 ? 1 : -1);
            }
        }, { passive: true });

        // Keyboard
        document.addEventListener('keydown', function(e) {
            if (!lightbox.classList.contains('is-active')) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') navigate(-1);
            if (e.key === 'ArrowRight') navigate(1);
        });
    }

    function openLightbox(images, index) {
        if (!lightbox) createLightbox();

        currentImages = images;
        currentIndex = index;
        showImage();

        document.body.style.overflow = 'hidden';
        lightbox.classList.add('is-active');

        // Preload adjacent
        preloadAdjacent();
    }

    function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('is-active');
        document.body.style.overflow = '';
    }

    function navigate(direction) {
        currentIndex = (currentIndex + direction + currentImages.length) % currentImages.length;
        showImage();
        preloadAdjacent();
    }

    function showImage() {
        lightboxImg.src = currentImages[currentIndex].full;
        lightboxImg.alt = currentImages[currentIndex].alt;
        lightboxCounter.textContent = (currentIndex + 1) + ' / ' + currentImages.length;
    }

    function preloadAdjacent() {
        [-1, 1].forEach(function(offset) {
            var idx = (currentIndex + offset + currentImages.length) % currentImages.length;
            var img = new Image();
            img.src = currentImages[idx].full;
        });
    }

    // ========================================
    // Init photo click handlers
    // ========================================
    function initPhotoClicks() {
        var cards = document.querySelectorAll('.realizacja-card__gallery');

        cards.forEach(function(gallery) {
            var photos = gallery.querySelectorAll('.realizacja-card__photo');
            var images = [];

            photos.forEach(function(photo) {
                images.push({
                    full: photo.dataset.full,
                    alt: photo.querySelector('img').alt
                });
            });

            photos.forEach(function(photo, index) {
                photo.addEventListener('click', function() {
                    openLightbox(images, index);
                });
            });
        });
    }

    // ========================================
    // Boot
    // ========================================
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        initToggles();
        initPhotoClicks();
    }
})();
